/* Bind Fish's variant-level controls to the exact product form in this theme. */
(() => {
  const controls = 'wishlist-button, wishlist-button-pdp, open-wishlists-button';
  function sync(button) {
    const formId = button.dataset.crownProductForm;
    if (!formId) return true;
    const input = document.getElementById(formId)?.querySelector('input[name="id"]');
    const id = input?.value;
    const valid = Boolean(id && /^\d+$/.test(id));
    button.setAttribute('aria-disabled', String(!valid));
    if (valid && button.dataset.variantId !== id) button.dataset.variantId = id;
    return valid;
  }
  document.addEventListener('change', (event) => {
    if (!event.target.matches('input[name="id"]')) return;
    const form = event.target.closest('form');
    document.querySelectorAll('[data-crown-product-form]').forEach((button) => {
      if (button.dataset.crownProductForm === form?.getAttribute('id')) sync(button);
    });
  });
  document.addEventListener('click', (event) => {
    const button = event.target.closest(controls);
    if (button && !sync(button)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const button = event.target.closest(controls);
    if (!button || event.target !== button) return;
    event.preventDefault();
    if (!event.repeat && sync(button)) button.click();
  });
})();
